var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBox',{ref:"searchbox",attrs:{"label":"Natureza de Operação:","placeholder":"Busca Natureza de Operação por Nome ou Código","funcaoBuscar":"getNaturezasOperacaoBox"},on:{"selected":_vm.handleSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }